// extracted by mini-css-extract-plugin
export default {"content_skill":"Skill_content_skill__MnU2H","content_rate":"Skill_content_rate__gFSCR","rate":"Skill_rate__u4Sd4","noRate":"Skill_noRate__mtmdt"};